import { Component, inject, AfterViewInit } from '@angular/core';
import { ShareDataService } from '../../../../shared/utils/share-data.service';
import { DashboardService } from '../../../../services/cng-sails/dashboard/dashboard.service';
import { NotificationService } from '../../../../shared/utils/notification.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommanService } from '../../../../shared/utils/comman.service';
import { DropDownService } from '../../../../services/cng-sails/drop-down.service';
import { FieldErrorDisplayComponent } from '../../../../shared/components/field-error-display/field-error-display.component';
import { formatDate, NgFor, NgIf, DecimalPipe, CurrencyPipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
interface SalesData {
  ga_code: string;
  sales_month: string;
  total_sales: number;
}
import {
  Chart,
  ChartData,
  ChartOptions,
  BarController,
  LineController,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Legend,
  Tooltip,
  PieController,
  ArcElement,
  Plugin
} from 'chart.js';
import DataLabelsPlugin, { Context as DataLabelContext } from 'chartjs-plugin-datalabels';
import { RoleService } from '../../../../services/role/role.service';
import { ChartDashboardComponent } from '../../../../shared/ChartDashboard/chart-dashboard.component';
import { InfoCardComponent } from "../../../../shared/InfoCardComponent/dashboard.component";
import { InfoCardGroupComponent } from "../../../../shared/InfoCardGroup/info-card-group.component";
import { DashboardLandingComponent } from "../landing-dashboard-page/dashboard_landing";
import { Router } from '@angular/router';
Chart.register(LineController, LineElement, PointElement, BarController, CategoryScale, LinearScale, BarElement, PieController, ArcElement, Legend, Tooltip, DataLabelsPlugin);
interface CustomDataLabelContext extends DataLabelContext {
  hovered?: boolean;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, NgSelectComponent, DecimalPipe, CurrencyPipe, ChartDashboardComponent, InfoCardComponent, CommonModule,InfoCardGroupComponent,DashboardLandingComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  shareDataService = inject(ShareDataService);
  subscription: Subscription;
  minToDate: string | null = null;
  fitnessToDate: string | null = null;
  totalCollectionMode = 0;
  totalCNGStations = 0;
  totalSales = 0;
  dashboardFilter: FormGroup;
  dashboardTrendsFilter: FormGroup;
  cngDashboardData: any[] = [];
  cngDashboardStationTypeWiseData: any[] = [];
  cngMomentTypeWiseData: any[] = [];
  cngOwnerShipTypeWiseData: any[] = [];
  cngStationData: any[] = [];
  cngSaledData: any[] = [];
  cngSaleAmountData: any[] = [];
  commonService = inject(CommanService);
  route = inject(Router);
  notificationService = inject(NotificationService);
  dashboardService = inject(DashboardService)
  fb = inject(FormBuilder);
  dropDownService = inject(DropDownService);
  roleService = inject(RoleService);
  PlantCodeDropDown: any[] = [];
  activeFlag: boolean = true;
  GA: any[] = [];
  now = new Date();
  startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  number_of_cng_station:any = 0;
  maxDate: any;
  isBulkEntry: boolean = false;
  station: any = [];
  ownership: any = [];
  movement: any = [];
  dashboardApplyFilter:any = []
  selectedRange: string = '30D';
  istrends:any = false;
  customEndMaxDate: string = '';
  customEndDisabled: boolean = false;
  constructor() {
    this.shareDataService.setData("Dashboard")
    this.subscription = new Subscription();
    this.dashboardFilter = this.fb.group({
      ga_code: [null],
      plant_code: [null],
      start_date: [formatDate(this.startDate, 'yyyy-MM-dd', 'en')],
      end_date: [formatDate(new Date(), 'yyyy-MM-dd', 'en')],
      month_name: ['']
    });
    this.dashboardTrendsFilter = this.fb.group({
      ga_code: [null],
      plant_code: [null],
      start_date: [formatDate(this.startDate, 'yyyy-MM-dd', 'en')],
      end_date: [formatDate(new Date(), 'yyyy-MM-dd', 'en')],
      month_name: ['']
    });
    const authUser = localStorage.getItem('authUser');
    this.istrends = authUser ? JSON.parse(authUser).trends == 1 : false;
  }

  ngOnInit() {
    if(!this.roleService.canView('dashboard') && !this.roleService.canModify('dashboard')){
        this.route.navigate(['/unauthorized']);
    }else{
    this.getGADropDown();
    const endDate = new Date();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const currentMonthName = monthNames[this.now.getMonth()];
    let data = {
      start_date: formatDate(this.startDate, 'yyyy-MM-dd', 'en'),
      end_date: formatDate(endDate, 'yyyy-MM-dd', 'en'),
      month_name: currentMonthName,
      ga_code: null,
      plant_code: null,
    }
    this.dashboardSubmit(data,'inlinChart');
    this.maxDate = this.commonService.getMaxDate();
    }
  };

  /*
*   function name: getDropDownService()
*   functionality: To check if all the form fields are valid  
*   parameters : 
*/
  private getGADropDown() {
    this.dropDownService.getGA().subscribe(item => {
      let response: any = item;
      if (response.code == 200) {
        this.GA = item.data;       
      }
    });
  };
  public getPlantCode(data: any) {
    this.dashboardFilter.get('plant_code')?.setValue(null);
    this.PlantCodeDropDown = [];
    this.dropDownService.getPlantCodeByGaName({ ga_code: data.ga_code }).subscribe(item => {
      let response: any = item;
      if (response.code == 200) {
        this.PlantCodeDropDown = item.data.sort((a, b) => a.plant_code.localeCompare(b.plant_code));;
      }
    });
  };
  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'right',
        labels: {
          usePointStyle: true, // Makes the legend items circular
          pointStyle: 'circle',
          font: {
            size: 10, // Adjust font size if needed
          },
          generateLabels: function (chart) {
            // Ensure that chart.data.labels is typed as an array of strings
            const labels = chart.data.labels as string[];

            if (!labels) {
              return []; // Return an empty array if labels are undefined
            }

            return chart.data.datasets[0].data.map((value: any, index) => {
              let numericValue = 0;

              // Ensure value is a number, or extract the number if it's a Point or BubbleDataPoint
              if (typeof value === 'number') {
                numericValue = value;
              } else if (Array.isArray(value) && value.length === 2) {
                numericValue = value[0];
              } else if (value && typeof value === 'object' && 'x' in value && 'y' in value) {
                numericValue = value.x;
              }

              const total = chart.data.datasets[0].data.reduce((sum: any, current) => {
                let val = 0;
                if (typeof current === 'number') {
                  val = current;
                } else if (Array.isArray(current) && current.length === 2) {
                  val = current[0];
                } else if (current && typeof current === 'object' && 'x' in current) {
                  val = current.x;
                }
                return sum + val;
              }, 0);

              const percentage = ((numericValue / total) * 100)?.toFixed(2);

              // Access backgroundColor with a fallback if it's a single color or undefined
              const backgroundColor = Array.isArray(chart.data.datasets[0].backgroundColor)
                ? chart.data.datasets[0].backgroundColor[index]
                : chart.data.datasets[0].backgroundColor;

              const label = labels?.[index] || 'Unknown'; // Use optional chaining to safely access the label
              return {
                text: `${label} - ${percentage}%`, // Concatenate the percentage with the label
                fillStyle: backgroundColor, // Add color to legend item
              };
            });
          }

        }, // Keeps legend hidden to focus on labels
      },
      datalabels: {
        color: '#fff',
        font: {
          size: 10,
          weight: 'bold',
          family: 'Arial',

        },
        offset: 4,
        rotation: 20,
        padding: 15, // Add padding
        formatter: (value: number | null, context) => {
          const data = context?.dataset?.data as number[] | undefined;
          if (!data || data.length === 0) return 'No data';
          const total = data.reduce((sum, current) => sum + (current ?? 0), 0);
          const percentage = ((value ?? 0) / total) * 100;
          if (percentage < 5) return '';
          //return `${percentage.toFixed(1)}%`;
          return value?.toFixed(2);
        },
        anchor: 'end',
        align: 'start',
        clip: true,
      },

    },
  };

  public pieChartOptionsByValue: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'right',
        labels: {
          usePointStyle: true, // Makes the legend items circular
          pointStyle: 'circle',
          font: {
            size: 12, // Adjust font size if needed
          },
        }, // Keeps legend hidden to focus on labels
      },
      datalabels: {
        color: '#fff',
        font: {
          size: 12,
          weight: 'bold',
          family: 'Arial',
        },
        offset: 5,
        rotation: 0,
        padding: 10,
        clamp: true,
        formatter: (value, context) => {
          // const labels = context.chart.data.labels;
          // if (labels && context.dataIndex < labels.length) {
          //   return `${labels[context.dataIndex]}: ${value}`;
          // }

          return value?.toFixed(2);
        },
        anchor: 'end',
        align: 'start',
        clip: true,
      },
    },
  };


  flattenData3(data: any[][]): any[] {
    const flattened = data.flat();
    return flattened.filter(item => item.ownership) // Filter items with `ownership` key
      .map(item => ({
        ownership: item.ownership,
        total_sales: item.total_sales || 0
      }));
  };
  createChart(canvasId: string, data: any[], labelKey: string, valueKey?: string) {
    const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
    const rawData = this.getCounts(data, labelKey, valueKey);
    const threshold =0;
    const totalValue = Object.values(rawData).reduce((acc, val) => acc + val, 0);
    const processedData = Object.entries(rawData).reduce(
      (acc: { labels: string[]; values: number[] }, [label, value]) => {
        const percentage = (value / totalValue) * 100;
        if (percentage < threshold) {
          acc.labels.push('Others');
          acc.values[acc.labels.indexOf('Others')] =
            (acc.values[acc.labels.indexOf('Others')] || 0) + value;
        } else {
          acc.labels.push(label);
          acc.values.push(value);
        }
        return acc;
      },
      { labels: [], values: [] }
    );
    const baseColors = [
      '#ca4db9', '#ff9663', '#889fff', '#97df77', '#A142F4', '#F4B400'
    ];
    while (processedData.labels.length > baseColors.length) {
      baseColors.push(
        `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`
      );
    }
    new Chart(ctx, {
      type: 'pie',
      data: {
        labels: processedData.labels,
        datasets: [
          {
            data: processedData.values,
            backgroundColor: baseColors,
          },
        ],
      },
      options: canvasId === 'pieChart1' ? this.pieChartOptions : this.pieChartOptions,
    });
  };

  getCounts(data: any[], key: string, valueKey?: string) {
    const counts: { [key: string]: number } = {};

    data.forEach((item) => {
      const label = item[key] || 'Unknown'; // Fallback label if key is missing
      const value = valueKey ? item[valueKey] || 0 : 1; // Use `valueKey` for summing

      counts[label] = (counts[label] || 0) + value;
    });

    return counts;
  };

  createLineBarChart(canvasId: string, data: any[]) {
    const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
    const months = data.map(item => item.sales_month);
    const totalSales = data.map(item => Number((item.total_sales / 100000)?.toFixed(2))); // Dividing by 100000 to match 'Amount in Lac'
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: months,
        datasets: [
          {
            type: 'line',
            label: 'Total Sales (Line)', // Visible in the legend
            data: totalSales,
            borderColor: '#4CAF50',
            backgroundColor: 'rgba(76, 175, 80, 0.2)',
            borderWidth: 3,
            fill: true,
            yAxisID: 'y',
            tension: 0.3, // For smooth curves
            pointBackgroundColor: '#FFFFFF',
            pointBorderColor: '#4CAF50',
            pointHoverBackgroundColor: '#4CAF50',
            pointHoverBorderColor: '#FFFFFF',
          },
          {
            type: 'bar',
            label: 'Total Sales (bar)', //
            data: totalSales,
            backgroundColor: 'rgba(0, 123, 255, 0.5)',
            borderColor: 'rgba(0, 123, 255, 0.5)',
            hoverBackgroundColor: '#36A2EB',
            hoverBorderColor: '#36A2EB',
            borderWidth: 1,
            yAxisID: 'y',
            barPercentage: 0.6,
            hoverBorderWidth: 2,
            datalabels: { display: false },
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: function (value: any) {
                return value?.toFixed(2);
              },
            },
          },
        },
        plugins: {
          legend: { display: true, position: 'top' },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                if (tooltipItem.datasetIndex === 1) return '';
                const value = tooltipItem.raw as number;
                return `${tooltipItem.label}: ${value?.toFixed(2)} Lac`;
              },
            },
          },
          datalabels: {
            align: 'end',
            color: '#000',
            formatter: (value, context) => {
              if (context.datasetIndex === 1) return '';
              return value?.toFixed(2);
            },
          },
        },
        hover: {
          mode: 'index',
          intersect: false,
        },
      },
    });
  };

  /*
 *   function name: isFieldValid()
 *   functionality: To check if all the form fields are valid  
 *   parameters : field
 */
  public isFieldValid(field: string) {
    let result = this.commonService.isFormFieldValid(field, this.dashboardFilter);
    return result;
  }

  /*
   *   function name: doLogin()
   *   functionality: To login into the application  
   *   parameters : none
   */

  public dashboardSubmit(data: any,type:any) {
    this.station = [];
    this.ownership = [];
    this.movement = [];
    let formData = {
      ...data,
      start_date: '2025-04-01'
    };
    const dashboardFilter$ = this.dashboardService.dashboardfilter(formData);
    const saleDashboard$ = this.dashboardService.saleDashboard(formData);
    const stationDashboard$ = this.dashboardService.getStationDash(formData);
    const saleAmountDashboard$ = this.dashboardService.saleAmountDashboard(formData);

    localStorage.removeItem('ownership_type_count');
    this.subscription = forkJoin([dashboardFilter$, saleDashboard$, saleAmountDashboard$, stationDashboard$])
      .subscribe(
        ([dashboardData, saleData, saleAmountData, stationData]) => {

          // CNG Dashboard Data
          let responseDashboard: any = dashboardData;
          if (responseDashboard.code == 200) {
            this.cngDashboardData = responseDashboard.data;
            var chartExist1 = Chart.getChart("pieChart1");
            const convertedCollections = this.cngDashboardData[0]?.map((item: { total_collection_amount: number; }) => ({
              ...item,
              total_collection_amount: Number((item.total_collection_amount / 100000)?.toFixed(2))
          }));
            if (chartExist1) chartExist1.destroy();
            this.createChart('pieChart1', convertedCollections, 'collection_mode', 'total_collection_amount');
            this.totalCollectionMode = convertedCollections.reduce((total: any, item: { total_collection_amount: any; }) => total + item.total_collection_amount, 0);
          } else {
            this.notificationService.notification('danger', responseDashboard.message, "", null);
          }

           // CNG Dashboard Data
          let responseSale: any = saleData;
          if (responseSale.code == 200) {
            this.cngSaledData = responseSale.data;
             this.number_of_cng_station = Number(this.cngSaledData[1][0].total_sales/100000)?.toFixed(2); 
            if (this.cngSaledData && this.cngSaledData.length > 0) {
              const flattenedData3 = this.flattenData3(this.cngSaledData);
              this.totalSales = this.cngSaledData.flat().reduce((total, item) => {
                return item.ownership !== null ? total + item.total_sales : total;
              }, 0);
              var chartExist2 = Chart.getChart("pieChart3");
              const convertedCollections = flattenedData3?.map((item: { total_sales: number; }) => ({
                ...item,
                total_sales: Number((item.total_sales / 100000)?.toFixed(2))
            }))
              if (chartExist2) chartExist2.destroy();
              this.createChart('pieChart3', convertedCollections, 'ownership', 'total_sales');
            }
          } else {
            this.notificationService.notification('danger', responseSale.message, "", null);
          }

           // CNG Dashboard Data
          let responseSaleAmount: any = saleAmountData;
          if (responseSaleAmount.code == 200) {
            this.cngSaleAmountData = this.addMissingMonthsStaticGA(responseSaleAmount?.data,formData?.ga_code);
            var chartExist3 = Chart.getChart("myLineChart");
            if (chartExist3) chartExist3.destroy();
            this.createLineBarChart('myLineChart', this.cngSaleAmountData);
          } else {
            this.notificationService.notification('danger', responseSaleAmount.message, "", null);
          }

           // CNG Dashboard Data
          let responseStation: any = stationData;
          if (responseStation.code == 200) {
            this.cngStationData = responseStation.data;
            localStorage.setItem('ownership_type_count', JSON.stringify(responseStation?.ownership_type_count));
            this.totalCNGStations = this.cngStationData.reduce((total, item) => total + item.ownership_count, 0);
            var chartExist4 = Chart.getChart("pieChart2");
            if (chartExist4) chartExist4.destroy();
            this.createChart('pieChart2', this.cngStationData, 'ownership', 'ownership_count');
          } else {
            this.notificationService.notification('danger', responseStation.message, "", null);
          }
        },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        }
      );

}
  public dashboardTrendsSubmit(data: any) {
    let formData = data;
    this.station = [];
    this.ownership = [];
    this.movement = [];
    this.dashboardApplyFilter = formData
    const stationTypeWise$ = this.dashboardService.dashboardStationTypeWiseQtyfilter(formData);
    const ownerShipTypeWise$ = this.dashboardService.dashboardOwnershipTypeWisefilter(formData);
    const momentTypeWise$ = this.dashboardService.dashboardMomentTypeWisefilter(formData);
    this.subscription = forkJoin([stationTypeWise$, ownerShipTypeWise$, momentTypeWise$])
      .subscribe(
        ([stationTypeWiseData, ownerShipTypeWiseData, momentTypeWiseData]) => {
          // CNG station Type Wise Data
          let response1: any = stationTypeWiseData;
          this.cngDashboardStationTypeWiseData = [];
          if (response1.code == 200) {
            function transformStationData(data: any) {
              return data.map((item: { station_type: any; total_quantity_sold: any; }) => ({
                label: item?.station_type || 'N/A',
                value: item?.total_quantity_sold || 0
              }));
            }
            this.cngDashboardStationTypeWiseData = transformStationData(response1.data);
            console.log(" this.cngDashboardStationTypeWiseData", this.cngDashboardStationTypeWiseData);
            this.station = this.cngDashboardStationTypeWiseData;


          } else {
            this.notificationService.notification('danger', response1.message, "", null);
          }
          // CNG ownerShip Type Wise Data
          let response2: any = ownerShipTypeWiseData;
          this.cngOwnerShipTypeWiseData = [];
          if (response2.code == 200) {
            this.cngOwnerShipTypeWiseData = response2.data;
            function transformOwnerShipTypeWiseData(data: any) {
              return data.map((item: { ownership_type: any; total_quantity_sold: any; }) => ({
                label: item?.ownership_type || 'N/A',
                value: item?.total_quantity_sold || 0
              }));
            }
            this.cngOwnerShipTypeWiseData = transformOwnerShipTypeWiseData(response2.data);
            console.log("cngOwnerShipTypeWiseData2222", this.cngOwnerShipTypeWiseData);
            this.ownership = this.cngOwnerShipTypeWiseData;
          } else {
            this.notificationService.notification('danger', response2.message, "", null);
          }
          // CNG moment Type Wise Data
          let response3: any = momentTypeWiseData;
          this.cngMomentTypeWiseData = [];
          if (response3.code == 200) {
            function transformOwnerShipTypeWiseData(data: any) {
              return data.map((item: { movement_type: any; total_quantity_sold: any; }) => ({
                label: item?.movement_type || 'N/A',
                value: item?.total_quantity_sold || 0
              }));
            }
            this.cngMomentTypeWiseData = transformOwnerShipTypeWiseData(response3.data);
            console.log("cngMomentTypeWiseData333", this.cngMomentTypeWiseData);
            this.movement = this.cngMomentTypeWiseData;

          } else {
            this.notificationService.notification('danger', response3.message, "", null);
          }
        },
        err => {
          this.notificationService.notification('danger', err.message, '', null);
        }
      );
  }
  public addMissingMonthsStaticGA(apiResponse: any, gaCode: string): SalesData[] {
    const monthOrder = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    if (apiResponse.length === 0) {
      const firstMonth = monthOrder[0];
      return [{ ga_code: gaCode, sales_month: firstMonth, total_sales: 0 }]; // return jan month if api array empty
    }

    const lastMonth = apiResponse.reduce((a: { sales_month: string; }, b: { sales_month: string; }) => {
      const indexA = monthOrder.indexOf(a.sales_month);
      const indexB = monthOrder.indexOf(b.sales_month);
      return (indexA > indexB) ? a : b;
    }).sales_month;

    const lastMonthIndex = monthOrder.indexOf(lastMonth);

    const existingMonthsMap = new Map<string, SalesData>();
    apiResponse.forEach((item: SalesData) => {
      existingMonthsMap.set(item.sales_month, item);
    });

    const modifiedResponse: SalesData[] = [];
    for (let i = 0; i <= lastMonthIndex; i++) {
      const month = monthOrder[i];
      if (existingMonthsMap.has(month)) {
        modifiedResponse.push(existingMonthsMap.get(month)!);
      } else {
        modifiedResponse.push({
          ga_code: gaCode,
          sales_month: month,
          total_sales: 0
        });
      }
  }
  return modifiedResponse;
}
  onEntryTypeChange(event: any) {
    this.getGADropDown();
    this.isBulkEntry = (event.target as HTMLInputElement)?.checked;
    const endDate = new Date();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const currentMonthName = monthNames[this.now.getMonth()];
    this.maxDate = this.commonService.getMaxDate();
    if (!(event.target as HTMLInputElement)?.checked) {
      console.log("--------------------main--------------------------")
      let data = {
        start_date: formatDate(this.startDate, 'yyyy-MM-dd', 'en'),
        end_date: formatDate(endDate, 'yyyy-MM-dd', 'en'),
        month_name: currentMonthName,
        ga_code: null,
        plant_code: null,
      }
      this.dashboardSubmit(data,'');
    } else{
      console.log("--------------------Trends--------------------------")
      const defaultStartDate = new Date();
      defaultStartDate.setDate(defaultStartDate.getDate() - 30);
      let data = {
        start_date: formatDate(defaultStartDate, 'yyyy-MM-dd', 'en'),
        end_date: formatDate(endDate, 'yyyy-MM-dd', 'en'),
        month_name: currentMonthName,
        ga_code: null,
        plant_code: null,
      }
      this.dashboardTrendsSubmit(data);
    }
  }
  selectRange(range: string) {
    this.selectedRange = range;
  
    if (range !== 'CUSTOM') {
      const today = new Date();
      let startDate = new Date();
    
      switch (range) {
        case '7D': startDate.setDate(today.getDate() - 7); break;
        case '15D': startDate.setDate(today.getDate() - 15); break;
        case '30D': startDate.setDate(today.getDate() - 30); break;
      }
      this.dashboardFilter.patchValue({
        start_date: this.formatDate(startDate),
        end_date: this.formatDate(today),
      });
      this.customEndMaxDate = '';
      this.customEndDisabled = false;
    } else {
      const today = new Date();
      let defaultStart = new Date(today);
      defaultStart.setDate(today.getDate() - 30);
      this.dashboardFilter.patchValue({
        start_date: this.formatDate(defaultStart),
        end_date: this.formatDate(today),
      });
      this.customEndMaxDate = '';
      this.customEndDisabled = false;
    }
  }
  
  limitCustomDateRange() {
    const startStr = this.dashboardFilter.value.start_date;
    const endStr = this.dashboardFilter.value.end_date;
    if (!startStr) {
      this.customEndMaxDate = '';
      this.customEndDisabled = true;
      return;
    }
    const start = new Date(startStr);
    let maxEnd = new Date(start);
    maxEnd.setDate(start.getDate() + 29);
    this.customEndMaxDate = this.formatDate(maxEnd);

    if (endStr) {
      const end = new Date(endStr);
      const diffMs = end.getTime() - start.getTime();
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (diffDays > 29) {
        this.notificationService.notification('info', 'You can only select a maximum of 30 days for custom date range. Dates have been cleared.', '', null);
        this.dashboardFilter.patchValue({
          start_date: '',
          end_date: ''
        });
        this.customEndDisabled = false;
      } else {
        this.customEndDisabled = false;
      }
    } else {
      this.customEndDisabled = false;
    }
  }
  
  resetToDefault() {
    this.selectRange('6M');
  }
  
  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}